var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.49967,
    cy: 7.50065,
    r: 1.66667,
    stroke: "#2058E7",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8337 12.5007C10.8337 13.4211 10.8337 14.1673 7.50033 14.1673C4.16699 14.1673 4.16699 13.4211 4.16699 12.5007C4.16699 11.5802 5.65938 10.834 7.50033 10.834C9.34127 10.834 10.8337 11.5802 10.8337 12.5007Z",
    stroke: "#2058E7",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 10.0007C1.66699 6.85795 1.66699 5.28661 2.6433 4.3103C3.61961 3.33398 5.19096 3.33398 8.33366 3.33398H11.667C14.8097 3.33398 16.381 3.33398 17.3573 4.3103C18.3337 5.28661 18.3337 6.85795 18.3337 10.0007C18.3337 13.1433 18.3337 14.7147 17.3573 15.691C16.381 16.6673 14.8097 16.6673 11.667 16.6673H8.33366C5.19096 16.6673 3.61961 16.6673 2.6433 15.691C1.66699 14.7147 1.66699 13.1433 1.66699 10.0007Z",
    stroke: "#2058E7",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 10H12.4997",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 7.5H11.6663",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 12.5H13.333",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateUser);
export default __webpack_public_path__ + "static/media/UpdateUser.9a4fdecd373c81c818d08f4599eeecb2.svg";
export { ForwardRef as ReactComponent };